import { render } from "./BanManage.vue?vue&type=template&id=29a8dc68&scoped=true"
import script from "./BanManage.vue?vue&type=script&lang=js"
export * from "./BanManage.vue?vue&type=script&lang=js"

import "./BanManage.vue?vue&type=style&index=0&id=29a8dc68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a8dc68"]])

export default __exports__